import Page from "../../components/Page";

export default function Home() {
  return <Page title="Accueil">Test </Page>;
}
